import React, { useRef } from "react";
import { useInView } from "framer-motion";
import SC from "./style";
import Counter from "./Counter";
import theme from "../../../theme";

const ImpactSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, amount: 0.3 });

  const stats = [
    { label: "🤝 Successful Projects", target: 100 },
    { label: "😊 Happy Users", target: 200 },
    { label: "📋 Activities Completed", target: 65000 },
  ];

  return (
    <div
      style={{
        background: theme.colors.background.main,
        padding: "1vw 5vw 3vw ",
      }}
    >
      <SC.Container>
        <SC.Title>Our Impact</SC.Title>
        <SC.Subtitle>
          Trusted by many, we're making a difference every day!
        </SC.Subtitle>

        <SC.StatsContainer>
          {stats.map((item, index) => {
            return (
              <SC.Stat
                key={index}
                ref={ref}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                <SC.StatNumber>
                  <Counter target={item.target} isInView={isInView} />
                  <span
                    style={{
                      fontSize: "clamp(2rem, 4vw, 3rem)",
                      background: theme.colors.gradient.themeGradient,
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontWeight: "bold",
                    }}
                  >
                    +
                  </span>
                </SC.StatNumber>
                <SC.StatLabel>{item.label}</SC.StatLabel>
              </SC.Stat>
            );
          })}
        </SC.StatsContainer>
      </SC.Container>
    </div>
  );
};

export default ImpactSection;
